import DataSheetPrintOptions from "csi/middleware/customView/options/DataSheetPrintOptions";
import DataSheetViewOptions from "csi/middleware/customView/options/DataSheetViewOptions";
import React, { FunctionComponent } from "react";
import SizeChartDataSheetViewOptions from "./SizeChartDataSheetViewOptions";

const SizeChartDataSheetOptionsTab: FunctionComponent = function SizeChartDataSheetOptionsTab() {
	return (
		<>
			<SizeChartDataSheetViewOptions />
			<DataSheetViewOptions />
			<DataSheetPrintOptions />
		</>
	);
};

export = SizeChartDataSheetOptionsTab;